import 'core-js/es/array/from';

/**
 * Add an anchor for each element with id
 */
function addAnchor (el: Element) {
  let id = el.id;
  if (!id) return;
  let anchor = document.createElement('a');
  anchor.classList.add('anchor');
  anchor.id = id;
  el.insertBefore(anchor, el.childNodes[0]);
  el.removeAttribute('id');
};

let elems = document.querySelectorAll('.article [id]');
Array.from(elems).forEach(addAnchor);